// extracted by mini-css-extract-plugin
module.exports = {"native":"ArticleContent_native___6O0a","groupedResources":"ArticleContent_groupedResources__Xxlvl","premium":"ArticleContent_premium__4HRL_"};